import { useEffect, useState } from "react";
import DocUpload from "./DocUpload";
import DocPreview from "./DocPreview";
//import DocField from "./DocField";
import { useLazyPlaygroundQuery } from "../../../api/admin/categoriesApi";

const defaultDocumentData = {
  category: "",
  documentBoundingBox: "",
  documentFields: "",
};

const PlaygroundPage = () => {
  const [selectedFile, setSelectedFile] = useState();
  const [documentData, setDocumentData] = useState(defaultDocumentData);
  const [isDocumentDataError, setIsDocumentDataError] = useState(undefined);
  const [dataDoc, setDataDoc] = useState();

  const [
    AIDocumentData,
    {
      isLoading: isAIDocumentDataLoading,
      isFetching: isAIDocumentDataFetching,
      isError: isAIDocumentDataError,
    },
  ] = useLazyPlaygroundQuery();

  useEffect(() => {
    setIsDocumentDataError(isAIDocumentDataError);
  }, [isAIDocumentDataError]);

  const processDocument = async () => {
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      const res = await AIDocumentData(formData);
      const parsedData = res.data.Data.extractedDocument.replace(
        /\\r\\n|\\/g,
        ""
      );
      const data = await JSON.parse(parsedData);
      const objectBounding = data.fields.map((el) => ({
        boundingBox: el.boundingBox,
        page: el.page,
        rotation:
          data?.pages?.find((page) => page.index === el.page)?.angle || 0,
      }));
      const fieldsObject = data.fields.map(({ fieldName, value }) => ({
        fieldName,
        fieldValue: value,
      }));
      setDocumentData({
        category: res.data.Data.categoryName,
        documentFields: fieldsObject,
        documentBoundingBox: objectBounding,
      });

      setDataDoc(res.data.Data);
    } catch (error) {
      console.error(error);
      setIsDocumentDataError(true);
    }
  };

  const handleReset = () => {
    setSelectedFile(undefined);
    setDocumentData(defaultDocumentData);
    setIsDocumentDataError(undefined);
  };

  return (
    <div className="w-full flex gap-8 justify-center p-4 flex-col xl:flex-row">
      <DocUpload
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        processDocument={processDocument}
        isAIDocumentDataLoading={
          isAIDocumentDataLoading || isAIDocumentDataFetching
        }
        handleReset={handleReset}
        data={documentData.documentFields}
        docCategory={documentData.category}
        isDocumentDataError={isDocumentDataError}
        dataDoc={dataDoc}
      />

      <DocPreview
        selectedFile={selectedFile}
        isAIDocumentDataLoading={
          isAIDocumentDataLoading || isAIDocumentDataFetching
        }
        boundingBox={documentData.documentBoundingBox}
        isDocumentDataError={isDocumentDataError}
      />
    </div>
  );
};

export default PlaygroundPage;
